import { GET_ALL_MEDITATIONS_SUCCESS } from '../actions/actionTypes';

export default function allMeditations(state = [], action) {
  switch (action.type) {
    case GET_ALL_MEDITATIONS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
